export const WideTriangle = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="13"
      height="39"
      viewBox="0 0 13 39"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13 20L-2.02604e-07 -5.68248e-07L0 39L13 20Z" />
    </svg>
  )
}
